import { useState } from "react";
import { GalleryPreviewContext } from ".";
import { ImageBody } from "../api";
import { isEqual } from "lodash";

const ContextProvider = ({ children }: { children: React.ReactNode }) => {

  const [currentImage, setCurrentImage] = useState<{ id: number, url: string, catalog_item: string } | undefined>(undefined)

  const [images, setImages] = useState<ImageBody[]>([]);

  const [open, setOpen] = useState(false)

  const prevImageHandler = () => {
    const currentIndex = images.findIndex(item => item.id === currentImage?.id)
    if (currentIndex !== -1) {
      const id = images[(currentIndex - 1) % images.length].id
      const url = images[(currentIndex - 1) % images.length].image_url
      const catalog = images[(currentIndex - 1) % images.length].catalogue_item
      setCurrentImage({ id, url, catalog_item: catalog })
    }
  }

  const nextImageHandler = () => {
    const currentIndex = images.findIndex(item => item.id === currentImage?.id)
    console.log(currentIndex, images)
    if (currentIndex !== -1) {
      const id = images[(currentIndex + 1) % images.length].id
      const url = images[(currentIndex + 1) % images.length].image_url
      const catalog_item = images[(currentIndex + 1) % images.length].catalogue_item
      setCurrentImage({ id, url, catalog_item })
    }
  }

  const togglePreviewHandler = (val: boolean) => {
    console.log("toggle called for preview")
    setOpen(val)
  }

  const currImageHandler = (currImage: {id: number, url: string, catalog_item: string} | undefined) => {
    setCurrentImage(currImage)
  }

  const safeSetImages = (imgArr: ImageBody[]) => {
  setImages(prevImages => {
    // Avoid update if arrays are deeply equal (or customize to shallow check if needed)
    if (isEqual(prevImages, imgArr)) {
      return prevImages;
    }
    return imgArr;
  });
};

  return (
    <GalleryPreviewContext.Provider
      value={{
        currentImageIndex: currentImage,
        setCurrentImage: currImageHandler,
        openPreview: open,
        setImages: safeSetImages,
        nextImage: nextImageHandler,
        prevImage: prevImageHandler,
        setOpenPreview: togglePreviewHandler
      }}
    >{children}
    </GalleryPreviewContext.Provider>
  )
}

export default ContextProvider;
